/* ClosetRehab 1nov26: banner MSI. Actualiza/oculta el banner en ficha (cambio de variante) y en carrito (re-pintado del drawer / cart.js). */
(function(){
  if (window.CRMSI) return;
  function money(cents, fmt){
    fmt = fmt || '${{amount}}';
    var n = Math.round(cents/100);
    var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(amount_no_decimals|amount|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/, s);
  }
  function update(el, cents){
    if (!el || isNaN(cents)) return;
    var min = parseInt(el.dataset.min, 10) || 2000000;
    el.dataset.amount = cents;
    var fmt = el.dataset.moneyFormat;
    var a = el.querySelector('[data-msi-3]'), b = el.querySelector('[data-msi-6]');
    if (a) a.textContent = money(Math.round(cents/3/100)*100, fmt);
    if (b) b.textContent = money(Math.round(cents/6/100)*100, fmt);
    el.hidden = !(cents > min);
  }
  function onVariant(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form') || document;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var vid = idInput.value;
    document.querySelectorAll('[data-cr-msi][data-mode="product"]').forEach(function(el){
      var j = el.querySelector('[data-msi-variants]'); if (!j) return;
      try { var map = JSON.parse(j.textContent); if (map[vid] != null) update(el, map[vid]); } catch(_){}
    });
  }
  function refreshCart(){
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', {headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){ document.querySelectorAll('[data-cr-msi][data-mode="cart"]').forEach(function(el){ update(el, c.total_price); }); })
      .catch(function(){});
  }
  document.addEventListener('change', function(e){ setTimeout(function(){ onVariant(e); }, 60); });
  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('cart:refresh', refreshCart);
  /* El drawer y la ficha se re-pintan desde Section Rendering: el Liquid ya trae los valores; el observer solo asegura el estado hidden. */
  new MutationObserver(function(){
    document.querySelectorAll('[data-cr-msi]:not([data-msi-ok])').forEach(function(el){
      el.setAttribute('data-msi-ok','');
      update(el, parseInt(el.dataset.amount, 10));
    });
  }).observe(document.documentElement, {childList:true, subtree:true});
  window.CRMSI = { update: update, refreshCart: refreshCart, money: money };
})();
